<section class="ipad_10g-section">
  <iframe
  [src]="iPad10gUrl"
  width="100%"
  height="800"
  style="border: none;"
  ></iframe>
  </section>